import React, { Component } from "react";
import { createPortal } from "react-dom";
import {
  PageHeader,
  Row,
  Col,
  Typography,
  notification,
  Spin,
  message,
  Modal,
  Tooltip,
} from "antd";
import {
  UpOutlined,
  DownOutlined,
  SearchOutlined,
  AppstoreOutlined,
  MenuOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import { ButtonItem, InputItem, SelectEscuelasItem, SegmentedItem, SubHeaderItem } from "../../../Components/Items";
import StatusCardHeader from "../../../Components/StatusCardHeader";
import VentaOnlineCard from "../../../Components/VentaOnlineCard";
import DraggableCard from "./Components/DraggableCard";
import DroppableColumn from "./Components/DroppableColumn";
import { DndContext, DragOverlay, PointerSensor } from "@dnd-kit/core";
import ModalGenerarGuia from "./Components/ModalGenerarGuia";
import ModalGenerarGuiaManual from "./Components/ModalGenerarGuiaManual";
import ModalGenerarOCDropshipping from "./Components/ModalGenerarOCDropshipping";
import ModalPrevisualizarArchivos from "../../../Components/ModalPrevisualizarArchivos";
import ModalProgramarRecoleccion from "./Components/ModalProgramarRecoleccion";
import ModalConfirmarTransito from "./Components/ModalConfirmarTransito";
import ModalConfirmarEstadoConCorreo from "./Components/ModalConfirmarEstadoConCorreo";
import ModalConfirmarEmpaquetadoSucursal from "./Components/ModalConfirmarEmpaquetadoSucursal";
import ModalConfirmarPagoTransferencia from "./Components/ModalConfirmarPagoTransferencia";
import ModalConciliarTransferenciasExcel from "./Components/ModalConciliarTransferenciasExcel";
import ModalGenerarPickingLote from "./Components/ModalGenerarPickingLote";
import ModalEstadoGeneralPedido from "./Components/ModalEstadoGeneralPedido";
import TarjetaGrupoInsumos from "./Components/TarjetaGrupoInsumos";
import { connect } from "react-redux";
import axios from "axios";
import { STATUS_CONFIG } from "./statusPaqueteConfig";
import {
  filtrarInsumosFisicos,
  agruparInsumosPorEstadoVisual,
} from "./estadoInsumoDerivado";
import {
  ORIGENES_FLUJO_REDUCIDO,
  getEstadosVisibles,
  esTransicionValida,
  ORIGENES_FILTRO,
} from "./useVentasEcommerceAcciones";

const { Title, Text } = Typography;

const sensorsConfig = [
  { sensor: PointerSensor, options: { activationConstraint: { distance: 8 } } },
];

const SPAN_FLUJO_REDUCIDO = { 0: 4, 1: 8, 2: 8, 5: 4 };

class VentasEcommerceDashboard extends Component {
  state = {
    localVisible: true,
    dropshippingVisible: true,
    manualVisible: true,
    pickupVisible: true,
    envioManualActivo: false,
    activeId: null,
    activeVenta: null,
    activeEnvio: null,
    ventas: [],
    loading: false,
    textoFiltro: "",
    mostrarDetalles: false,
    // -- Estados para los modales
    modalGuiaVisible: false,
    modalGuiaManualVisible: false,
    modalOCVisible: false,
    selectedVentaId: null,
    selectedOrigenKey: null,
    modalPreviewVisible: false,
    archivoPreview: null,
    modalRecoleccionVisible: false,
    recoleccionCarrier: null,
    recoleccionOrigen: null,
    modalTransitoVisible: false,
    transitoVenta: null,
    transitoEnvio: null,
    transitoOrigenKey: null,
    modalEstadoCorreoVisible: false,
    estadoCorreoVenta: null,
    estadoCorreoEnvio: null,
    estadoCorreoOrigen: null,
    estadoCorreoNuevoEstado: null,
    modalEmpaqueSucursalVisible: false,
    modalConfirmarTransferenciaVisible: false,
    ventaAConfirmarTransferencia: null,
    modalConciliarExcelVisible: false,
    modalPickingLoteVisible: false,
    modalEstadoGeneralVisible: false,
    estadoGeneralVentaId: null,
    soloActualizarEmpaquetado: false,
    correosConfig: {},
    escuelaFiltroId: null,
    origenFiltro: null,
  };

  getFiltroKey = () => `ventasEcommerceFiltro_${this.props.empresaId}`;

  guardarFiltro = (origenFiltro) => {
    try {
      localStorage.setItem(this.getFiltroKey(), JSON.stringify({ origenFiltro, timestamp: Date.now() }));
    } catch (e) {}
  };

  cargarFiltroGuardado = () => {
    try {
      const saved = localStorage.getItem(this.getFiltroKey());
      if (!saved) return null;
      const { origenFiltro, timestamp } = JSON.parse(saved);
      if (Date.now() - timestamp >= 10 * 60 * 1000) {
        localStorage.removeItem(this.getFiltroKey());
        return null;
      }
      return origenFiltro;
    } catch (e) { return null; }
  };

  componentDidMount() {
    const filtroGuardado = this.cargarFiltroGuardado();
    if (filtroGuardado) this.setState({ origenFiltro: filtroGuardado });
    this.selectVentas();
    this.consultarConfiguracionEnvioManual();
    this.consultarConfiguracionCorreos();
  }

  consultarConfiguracionCorreos = () => {
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionCorreos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          this.setState({ correosConfig: res.data.data });
        }
      })
      .catch(() => {
      });
  };

  getEnviarCorreoDefault = (estado, origenKey) => {
    const { correosConfig } = this.state;
    const esSucursal = origenKey === "entrega_sucursal";
    const key = `estado${parseInt(estado)}${esSucursal ? "Sucursal" : ""}`;
    const cfg = correosConfig?.estadoPedido?.[key];
    return cfg?.enviarPorDefecto !== false;
  };

  consultarConfiguracionEnvioManual = () => {
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionApis",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          this.setState({
            envioManualActivo: !!res.data.data.envioManual?.activo,
          });
        }
      })
      .catch(() => {
      });
  };

  selectVentas = () => {
    const { empresaId, headersToken } = this.props;
    const { textoFiltro, escuelaFiltroId } = this.state;

    axios
      .post(
        "ventasEcommerce/selectVentas",
        { empresaId, textoFiltro, escuelaFiltroId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ ventas: res.data.data }, () => {
            if (!this.colapsoInicialHecho) {
              this.colapsoInicialHecho = true;
              this.setState({
                localVisible: this.origenTieneCards("bodega_local"),
                manualVisible: this.origenTieneCards("envio_manual"),
                pickupVisible: this.origenTieneCards("entrega_sucursal"),
                dropshippingVisible:
                  this.origenTieneCards("dropshipping_urrea"),
              });

              // El dashboard siempre muestra un solo tipo de envío a la
              // vez — si no hay uno ya elegido (guardado o de una sesión
              // previa), se elige por defecto el primero que tenga
              // pedidos pendientes, o si ninguno tiene, el primero de la lista.
              if (!this.state.origenFiltro) {
                const origenDefault =
                  ORIGENES_FILTRO.find((o) => this.origenTieneCards(o.key))?.key ||
                  ORIGENES_FILTRO[0].key;
                this.setState({ origenFiltro: origenDefault });
                this.guardarFiltro(origenDefault);
              }
            }
          });
        } else {
          notification.error({ message: "Error al obtener ventas" });
        }
      })
      .catch((err) => {
        notification.error({ message: "Error de conexión con el servidor" });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  seguirEmpaquetando = (venta, envio) => {
    if (envio.origen === "entrega_sucursal") {
      this.setState({
        modalEmpaqueSucursalVisible: true,
        selectedVentaId: venta._id,
        selectedOrigenKey: envio.origen,
        soloActualizarEmpaquetado: true,
      });
    } else if (envio.origen === "envio_manual") {
      this.setState({
        modalGuiaManualVisible: true,
        selectedVentaId: venta._id,
        selectedOrigenKey: envio.origen,
        soloActualizarEmpaquetado: true,
      });
    }
  };

  origenTieneCards = (originKey) =>
    this.state.ventas.some((venta) =>
      venta.cotizacionesEnvioOnline.some((envio) => envio.origen === originKey),
    );

  toggleVista = () => {
    this.setState((prevState) => ({
      mostrarDetalles: !prevState.mostrarDetalles,
    }));
  };

  getCardsForColumn = (status, originKey) => {
    const { ventas } = this.state;
    let cards = [];
    const statusInt = parseInt(status);
    const esOrigenConSplit =
      originKey === "entrega_sucursal" || originKey === "envio_manual";

    ventas.forEach((venta) => {
      venta.cotizacionesEnvioOnline.forEach((envio) => {
        if (envio.origen !== originKey) return;

        let grupos = null;
        let totalFisicos = 0;
        if (esOrigenConSplit) {
          grupos = agruparInsumosPorEstadoVisual(venta, envio);
          totalFisicos = filtrarInsumosFisicos(venta.insumos).length;
        }

        if (envio.estadoPaquete === statusInt) {
          let isDragDisabled = statusInt === 0 || statusInt === 5;
          if (originKey === "dropshipping_urrea" && statusInt >= 2) {
            isDragDisabled = true;
          }
          if (originKey === "entrega_sucursal" && statusInt === 4) {
            isDragDisabled = true;
          }

          const grupoAlPar = grupos ? grupos.get(statusInt) : null;
          const hayOtrosGrupos = grupos && grupos.size > 1;
          const badgeGrupo =
            hayOtrosGrupos && grupoAlPar
              ? `${grupoAlPar.length} de ${totalFisicos} insumos`
              : null;

          cards.push(
            <DraggableCard
              key={`${venta._id}-${envio.origen}`}
              venta={venta}
              envio={envio}
              isDragDisabled={isDragDisabled}
              mostrarDetalles={this.state.mostrarDetalles}
              permisoConfirmarPago={this.props.permisoConfirmarPago}
              badgeGrupo={badgeGrupo}
              onVerGuia={() =>
                this.abrirPrevisualizacionGuia(envio, venta.serieNumero)
              }
              onVerificarPago={this.verificarPagoVenta}
              onVerificarPagoMattilda={this.verificarPagoMattildaVenta}
              onPagarManualmente={this.pagarManualmente}
              onConfirmarTransferencia={this.confirmarPagoTransferencia}
              onReenviarCorreo={() => this.reenviarCorreoEstado(venta, envio)}
              onVerEstadoGeneral={() =>
                this.setState({
                  modalEstadoGeneralVisible: true,
                  estadoGeneralVentaId: venta._id,
                })
              }
              onSeguirEmpaquetando={
                esOrigenConSplit &&
                envio.estadoPaquete >= 2 &&
                (venta.insumos || []).some(
                  (ins) => !ins.servicio && !ins.dropshipping && !ins.libroVirtual && !ins.empaquetado,
                )
                  ? () => this.seguirEmpaquetando(venta, envio)
                  : null
              }
            />,
          );
        }

        if (esOrigenConSplit && grupos) {
          const grupoDeEstaColumna = grupos.get(statusInt);
          if (grupoDeEstaColumna && statusInt !== envio.estadoPaquete) {
            cards.push(
              <TarjetaGrupoInsumos
                key={`${venta._id}-${envio.origen}-grupo-${statusInt}`}
                venta={venta}
                envio={envio}
                insumos={grupoDeEstaColumna}
                estado={statusInt}
                onSeguirEmpaquetando={this.seguirEmpaquetando}
                onVerEstadoGeneral={() =>
                  this.setState({
                    modalEstadoGeneralVisible: true,
                    estadoGeneralVentaId: venta._id,
                  })
                }
              />,
            );
          }
        }
      });
    });

    return cards.length > 0 ? (
      cards
    ) : (
      <div style={{ textAlign: "center", marginTop: 20, opacity: 0.3 }}>
        <Text style={{ fontSize: 10 }}>VACÍO</Text>
      </div>
    );
  };

  getColumnasParaOrigen = (originKey) => {
    const esFlujoReducido = ORIGENES_FLUJO_REDUCIDO.includes(originKey);
    return getEstadosVisibles(originKey).map((status) => ({
      status,
      span: esFlujoReducido ? SPAN_FLUJO_REDUCIDO[status] : 4,
    }));
  };

  renderColumnSection = (
    originKey,
    label,
    color,
    isOpen,
    toggleKey,
    unicaVisible,
  ) => {
    const alturaDinamica = unicaVisible ? "800px" : "400px";

    return (
      <div style={{ marginBottom: "6px" }}>
        <div
          onClick={() => this.setState({ [toggleKey]: !isOpen })}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 6,
            backgroundColor: "#f9f9f9",
            borderRadius: 8,
            padding: "2px 12px",
            cursor: "pointer",
            border: `1px solid ${color}20`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: 6,
                height: 16,
                backgroundColor: color,
                borderRadius: 6,
                marginRight: 8,
              }}
            />
            <Title
              level={5}
              style={{
                color: color,
                margin: 0,
                fontSize: 13,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              {label}
            </Title>
          </div>
          {isOpen ? (
            <UpOutlined style={{ color }} />
          ) : (
            <DownOutlined style={{ color }} />
          )}
        </div>

        {isOpen && (
          <Row gutter={4}>
            {this.getColumnasParaOrigen(originKey).map(({ status, span }) => {
              const esColumnaDoble = span === 8;

              return (
                <Col key={`${originKey}-${status}`} span={span}>
                  <DroppableColumn
                    id={`${originKey}-${status}`}
                    statusColor={STATUS_CONFIG[status].color}
                    style={{
                      height: alturaDinamica,
                      overflowY: "auto",
                      background: "#f9f9f9",
                      borderRadius: "10px",
                      padding: "6px",
                      border: `1px solid ${color}30`,
                      ...(esColumnaDoble
                        ? { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "6px", alignContent: "start" }
                        : {}),
                    }}
                  >
                    {this.getCardsForColumn(status, originKey)}
                  </DroppableColumn>
                </Col>
              );
            })}
          </Row>
        )}
      </div>
    );
  };

  handleDragStart = (event) => {
    const { active } = event;
    const { venta, envio, tipo, estadoGrupo, insumosGrupo } = active.data.current;

    this.setState({
      activeId: active.id,
      activeVenta: venta,
      activeEnvio: envio,
      activeTipo: tipo || "venta",
      activeEstadoGrupo: estadoGrupo,
      activeInsumosGrupo: insumosGrupo,
    });
  };

  handleDragEndGrupo = (venta, envio, origenKey, estadoGrupo, estadoDestino) => {
    if (origenKey !== envio.origen || estadoDestino === estadoGrupo) return;
    if (estadoGrupo === 5) return; // ya entregado, no hay a dónde avanzarlo

    if (estadoGrupo === 1) {
      if (estadoDestino !== 2) {
        return notification.warning({
          message: "Movimiento no permitido",
          description:
            "Estos insumos aún no están empaquetados; solo se pueden mover a 'Empaquetado' para marcarlos como listos.",
        });
      }
      return this.seguirEmpaquetando(venta, envio);
    }

    // estadoGrupo === 2: empaquetados pero aún sin entregar físicamente.
    if (estadoDestino < 3) {
      return notification.warning({
        message: "Movimiento no permitido",
        description: "Estos insumos ya están empaquetados; para avanzarlos, registra su entrega.",
      });
    }
    this.props.history.push("/panel/entregarInsumosVenta", { id: venta._id });
  };

  handleDragEnd = (event) => {
    const { active, over } = event;

    this.setState({
      activeId: null,
      activeVenta: null,
      activeEnvio: null,
      activeTipo: null,
      activeEstadoGrupo: null,
      activeInsumosGrupo: null,
    });
    if (!over) return;

    const [origenKey, estadoDestinoStr] = over.id.split("-");
    const estadoDestino = parseInt(estadoDestinoStr);
    const { venta, envio, tipo, estadoGrupo } = active.data.current;

    if (tipo === "grupo") {
      return this.handleDragEndGrupo(venta, envio, origenKey, estadoGrupo, estadoDestino);
    }

    if (origenKey === "entrega_sucursal" && estadoDestino === 4) {
      return notification.warning({
        message: "Movimiento no permitido",
        description:
          "Los pedidos de Entrega en Sucursal no pasan por 'En tránsito'. Pásalo directo a 'Entregado'.",
      });
    }

    if (!esTransicionValida(origenKey, envio.estadoPaquete, estadoDestino)) {
      return notification.warning({
        message: "Movimiento no permitido",
        description: "Los pedidos deben seguir el orden lógico del flujo.",
      });
    }

    if (estadoDestino === 2) {
      if (origenKey === "dropshipping_urrea") {
        this.setState({
          modalOCVisible: true,
          selectedVentaId: venta._id,
          selectedOrigenKey: origenKey,
        });
      } else if (origenKey === "envio_manual") {
        this.setState({
          modalGuiaManualVisible: true,
          selectedVentaId: venta._id,
          selectedOrigenKey: origenKey,
          soloActualizarEmpaquetado: false,
        });
      } else if (origenKey === "entrega_sucursal") {
        // Pickup: empaquetado no requiere guía/OC, sólo confirmación + picking.
        this.setState({
          modalEmpaqueSucursalVisible: true,
          selectedVentaId: venta._id,
          selectedOrigenKey: origenKey,
          soloActualizarEmpaquetado: false,
        });
      } else {
        this.setState({
          modalGuiaVisible: true,
          selectedVentaId: venta._id,
          selectedOrigenKey: origenKey,
        });
      }
    } else if (estadoDestino === 3) {
      if (origenKey === "dropshipping_urrea") {
        Modal.confirm({
          title: "Confirmar paso a Orden de Entrega",
          content:
            "¿Confirmas que ya gestionaste la recolección de este paquete directamente en el portal del proveedor (Urrea)?",
          okText: "Sí, confirmar",
          cancelText: "Cancelar",
          onOk: () => {
            this.actualizarEstadoBD(venta._id, origenKey, estadoDestino);
          },
        });
      } else if (
        origenKey === "envio_manual" ||
        origenKey === "entrega_sucursal"
      ) {
        const insumosSinEmpaquetar = (venta.insumos || []).filter(
          (ins) => !ins.servicio && !ins.dropshipping && !ins.libroVirtual && !ins.empaquetado,
        );

        const abrirModalEstadoCorreo = () => {
          this.setState({
            modalEstadoCorreoVisible: true,
            estadoCorreoVenta: venta,
            estadoCorreoEnvio: envio,
            estadoCorreoOrigen: origenKey,
            estadoCorreoNuevoEstado: estadoDestino,
          });
        };

        if (insumosSinEmpaquetar.length > 0) {
          return Modal.confirm({
            title: "⚠️ Insumos sin empaquetar",
            content: `Este pedido tiene ${insumosSinEmpaquetar.length} insumo(s) que aún no se han marcado como empaquetados. ¿Confirmas pasarlo a "Orden de entrega" de todas formas?`,
            okText: "Sí, continuar",
            cancelText: "Cancelar",
            onOk: abrirModalEstadoCorreo,
          });
        }

        abrirModalEstadoCorreo();
      } else {
        this.setState({
          modalRecoleccionVisible: true,
          recoleccionCarrier: envio.carrier,
          recoleccionOrigen: origenKey,
        });
      }
    } else if (estadoDestino === 4) {
      const esDropshipping = origenKey === "dropshipping_urrea";
      const insumosDelPaquete = (venta.insumos || []).filter(
        (ins) => !ins.servicio && !!ins.dropshipping === esDropshipping && !ins.libroVirtual,
      );

      const todosEntregados = insumosDelPaquete.every(
        (ins) => (ins.entregado || 0) >= ins.cantidad,
      );

      if (!todosEntregados) {
        return Modal.confirm({
          title: "⚠️ Falta salida de inventario",
          content:
            "Para que el paquete pueda salir, primero debes confirmar la salida de los insumos en el sistema. ¿Ir a la pantalla de entrega?",
          okText: "Ir a Entregar Insumos",
          cancelText: "Cancelar",
          onOk: () => {
            this.props.history.push("/panel/entregarInsumosVenta", {
              id: venta._id,
            });
          },
        });
      }

      if (origenKey === "envio_manual") {
        this.setState({
          modalEstadoCorreoVisible: true,
          estadoCorreoVenta: venta,
          estadoCorreoEnvio: envio,
          estadoCorreoOrigen: origenKey,
          estadoCorreoNuevoEstado: estadoDestino,
        });
      } else {
        this.setState({
          modalTransitoVisible: true,
          transitoVenta: venta,
          transitoEnvio: envio,
          transitoOrigenKey: origenKey,
        });
      }
    } else if (
      estadoDestino === 5 &&
      (origenKey === "envio_manual" || origenKey === "entrega_sucursal")
    ) {
      const insumosDelPaquete = (venta.insumos || []).filter(
        (ins) => !ins.servicio && !ins.dropshipping && !ins.libroVirtual,
      );
      const todosEntregados = insumosDelPaquete.every(
        (ins) => (ins.entregado || 0) >= ins.cantidad,
      );
      if (!todosEntregados) {
        return Modal.confirm({
          title: "Falta salida de inventario",
          content:
            "Antes de marcar el pedido como entregado al cliente, confirma la salida de los insumos en el sistema. ¿Ir a la pantalla de entrega?",
          okText: "Ir a Entregar Insumos",
          cancelText: "Cancelar",
          onOk: () => {
            this.props.history.push("/panel/entregarInsumosVenta", {
              id: venta._id,
            });
          },
        });
      }
      this.setState({
        modalEstadoCorreoVisible: true,
        estadoCorreoVenta: venta,
        estadoCorreoEnvio: envio,
        estadoCorreoOrigen: origenKey,
        estadoCorreoNuevoEstado: estadoDestino,
      });
    }
  };

  verificarPagoVenta = (ventaId) => {
    const { empresaId, headersToken } = this.props;
    return axios
      .post(
        "ventasEcommerce/verificarPagoConekta",
        { ventaId, empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        const data = res.data || {};
        if (!data.success) {
          notification.error({
            message: "No se pudo verificar el pago",
            description: data.message || "Inténtalo de nuevo en unos minutos.",
          });
          return;
        }
        if (data.paid) {
          notification.success({
            message: data.alreadyApplied
              ? "El pago ya estaba registrado"
              : "Pago confirmado",
            description: data.message,
          });
          this.selectVentas();
        } else {
          notification.info({
            message: "Pago aún pendiente",
            description: data.message || "Vuelve a intentar en unos minutos.",
          });
        }
      })
      .catch((err) => {
        console.error("Error verificando pago Conekta:", err);
        notification.error({
          message: "Error verificando el pago",
          description: "No se pudo comunicar con el servidor.",
        });
      });
  };

  verificarPagoMattildaVenta = (ventaId) => {
    const { empresaId, headersToken } = this.props;
    return axios
      .post(
        "ventasEcommerce/verificarPagoMattilda",
        { ventaId, empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        const data = res.data || {};
        if (!data.success) {
          notification.error({
            message: "No se pudo verificar el pago",
            description: data.message || "Inténtalo de nuevo en unos minutos.",
          });
          return;
        }
        if (data.paid) {
          notification.success({
            message: data.alreadyApplied
              ? "El pago ya estaba registrado"
              : "Pago confirmado",
            description: data.message,
          });
          this.selectVentas();
        } else {
          notification.info({
            message: "Pago aún pendiente",
            description: data.message || "Vuelve a intentar en unos minutos.",
          });
        }
      })
      .catch((err) => {
        console.error("Error verificando pago Mattilda:", err);
        notification.error({
          message: "Error verificando el pago",
          description: "No se pudo comunicar con el servidor.",
        });
      });
  };

  pagarManualmente = (ventaId) => {
    const { empresaId, headersToken } = this.props;
    return new Promise((resolve) => {
      Modal.confirm({
        title: "Confirmar pago",
        content:
          "Se marcará esta venta como pagada de forma manual. Se generará la póliza y el pago correspondiente, y se notificará al cliente. ¿Deseas continuar?",
        okText: "Sí, confirmar pago",
        cancelText: "Cancelar",
        onCancel: () => resolve(),
        onOk: () =>
          axios
            .post(
              "ventasEcommerce/pagarManualmente",
              { ventaId, empresaId },
              { headers: headersToken },
            )
            .then((res) => {
              const data = res.data || {};
              if (!data.success) {
                notification.error({
                  message: "No se pudo aplicar el pago",
                  description:
                    data.message || "Inténtalo de nuevo en unos minutos.",
                });
                return;
              }
              notification.success({
                message: data.alreadyApplied
                  ? "El pago ya estaba registrado"
                  : "Pago confirmado",
                description: data.message,
              });
              this.selectVentas();
            })
            .catch((err) => {
              console.error("Error aplicando pago manual:", err);
              notification.error({
                message: "Error aplicando el pago",
                description: "No se pudo comunicar con el servidor.",
              });
            })
            .finally(() => resolve()),
      });
    });
  };

  confirmarPagoTransferencia = (ventaId) => {
    const venta = this.state.ventas.find((v) => v._id === ventaId);
    if (!venta) return;
    this.setState({
      modalConfirmarTransferenciaVisible: true,
      ventaAConfirmarTransferencia: venta,
    });
  };

  reenviarCorreoEstado = (venta, envio) => {
    const { empresaId, headersToken } = this.props;
    const estado = envio.estadoPaquete ?? 0;
    const labelEstado = STATUS_CONFIG[estado]?.label || "este estado";
    const nombreCliente =
      `${venta.clienteOnline?.nombre || ""} ${
        venta.clienteOnline?.apellidoPaterno || ""
      }`.trim() ||
      venta.clienteOnline?.email ||
      "el cliente";

    return new Promise((resolve) => {
      Modal.confirm({
        title: "¿Reenviar correo al cliente?",
        content: `Se volverá a enviar el correo de "${labelEstado}" a ${nombreCliente} (${
          venta.clienteOnline?.email || "sin correo"
        }).`,
        okText: "Sí, reenviar",
        cancelText: "Cancelar",
        onCancel: () => resolve(),
        onOk: () =>
          axios
            .post(
              "ventasEcommerce/reenviarCorreoEstado",
              {
                ventaId: venta._id,
                empresaId,
                origenKey: envio.origen,
                estado,
              },
              { headers: headersToken },
            )
            .then((res) => {
              if (res.data.success === 1) {
                notification.success({
                  message: "Correo reenviado",
                  description: res.data.message,
                });
              } else {
                notification.error({
                  message: "No se pudo reenviar el correo",
                  description: res.data.message,
                });
              }
            })
            .catch(() =>
              notification.error({
                message: "Error de conexión",
                description: "No se pudo comunicar con el servidor.",
              }),
            )
            .finally(() => resolve()),
      });
    });
  };

  actualizarEstadoBD = (ventaId, origenKey, nuevoEstado) => {
    const { empresaId, headersToken } = this.props;
    this.setState({ loading: true });

    axios
      .post(
        "ventasEcommerce/actualizarEstadoPaquete",
        { ventaId, origenKey, nuevoEstado, empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 1) {
          message.success("Estado actualizado correctamente");
          this.selectVentas();
        } else {
          notification.error({ message: "No se pudo actualizar el estado" });
        }
      })
      .catch(() =>
        notification.error({ message: "Error al comunicar con el servidor" }),
      )
      .finally(() => this.setState({ loading: false }));
  };

  abrirPrevisualizacionGuia = (envio, serieNumero) => {
    if (!envio.labelUrl) return;

    this.setState({
      modalPreviewVisible: true,
      archivoPreview: {
        url: envio.labelUrl,
        name: `Guia_${envio.carrier}_${serieNumero}.pdf`,
        mime: "application/pdf",
      },
    });
  };

  render() {
    const {
      localVisible,
      dropshippingVisible,
      modalGuiaVisible,
      selectedVentaId,
      selectedOrigenKey,
    } = this.state;
    return (
      <DndContext
        onDragStart={this.handleDragStart}
        sensors={sensorsConfig}
        onDragEnd={this.handleDragEnd}
      >
        <PageHeader
          title="Ventas eCommerce"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />

        <SubHeaderItem style={{ marginBottom: 0, borderRadius: "6px 6px 0 0" }}>
          <SegmentedItem
            options={ORIGENES_FILTRO.map((o) => ({ value: o.key, label: o.label }))}
            value={this.state.origenFiltro}
            onChange={(val) => {
              this.setState({ origenFiltro: val });
              this.guardarFiltro(val);
            }}
          />
        </SubHeaderItem>

        <SubHeaderItem style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          {this.props.escuelaActivo && (
            <SelectEscuelasItem
              allowClear
              placeholder="Filtrar por escuela"
              style={{ width: 220 }}
              value={this.state.escuelaFiltroId}
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              onChange={(val) =>
                this.setState({ escuelaFiltroId: val || null }, this.selectVentas)
              }
            />
          )}
          <InputItem
            type="text"
            placeholder="Buscar por folio o cliente..."
            value={this.state.textoFiltro}
            onChange={(e) =>
              this.setState({ textoFiltro: e.target.value })
            }
            allowClear
            style={{ width: "300px" }}
            prefix={<SearchOutlined />}
          />
          <ButtonItem
            key="refresh"
            lila
            onClick={this.selectVentas}
            className="botonAgregar"
            icon={<SearchOutlined />}
          />
          {this.props.permisoConfirmarPago && (
            <Tooltip title="Conciliar transferencias por Excel">
              <ButtonItem
                className="botonAgregar"
                verde
                icon={<FileExcelOutlined />}
                onClick={() => this.setState({ modalConciliarExcelVisible: true })}
              />
            </Tooltip>
          )}
          <Tooltip title="Descargar múltiples guías de picking">
            <ButtonItem
              botonAncho
              naranja
              icon={<FilePdfOutlined />}
              onClick={() => this.setState({ modalPickingLoteVisible: true })}
            />
          </Tooltip>
          <Tooltip title="Importar Ventas de Libros">
            <ButtonItem
              className="botonAgregar"
              azul
              icon={<ImportOutlined />}
              onClick={() => this.props.history.push("/panel/importarVentasLibros")}
            />
          </Tooltip>
          <Tooltip
            title={
              this.state.mostrarDetalles
                ? "Vista Simple"
                : "Vista Detallada"
            }
          >
            <ButtonItem
              className="botonAgregar"
              blanco
              icon={
                this.state.mostrarDetalles ? (
                  <MenuOutlined />
                ) : (
                  <AppstoreOutlined />
                )
              }
              onClick={this.toggleVista}
            />
          </Tooltip>
        </SubHeaderItem>
        <Spin spinning={this.state.loading} tip="Cargando pedidos...">
          <div>
            <Row gutter={6}>
              {this.getColumnasParaOrigen(this.state.origenFiltro).map(({ status, span }) => (
                <Col key={status} span={span}>
                  <StatusCardHeader {...STATUS_CONFIG[status]} />
                </Col>
              ))}
            </Row>
            <div
              style={{
                overflowX: "hidden",
                width: "100%",
                position: "relative",
              }}
            >
              {/* Solo se ve un origen a la vez — el que esté seleccionado arriba. */}
              {this.state.origenFiltro === 'bodega_local' &&
                this.renderColumnSection(
                  "bodega_local",
                  "Envíos Automatizados",
                  "#13c2c2",
                  localVisible,
                  "localVisible",
                  true,
                )}

              {this.state.origenFiltro === 'envio_manual' &&
                this.renderColumnSection(
                  "envio_manual",
                  "Envíos Manuales",
                  "#fa8c16",
                  this.state.manualVisible,
                  "manualVisible",
                  true,
                )}

              {this.state.origenFiltro === 'entrega_sucursal' &&
                this.renderColumnSection(
                  "entrega_sucursal",
                  "Entrega en Sucursal",
                  "#eb2f96",
                  this.state.pickupVisible,
                  "pickupVisible",
                  true,
                )}

              {this.state.origenFiltro === 'dropshipping_urrea' &&
                this.renderColumnSection(
                  "dropshipping_urrea",
                  "Dropshipping",
                  "#73d13d",
                  dropshippingVisible,
                  "dropshippingVisible",
                  true,
                )}
            </div>
          </div>
        </Spin>
        <ModalGenerarGuia
          visible={modalGuiaVisible}
          ventaId={selectedVentaId}
          origenKey={selectedOrigenKey}
          onCancel={() => this.setState({ modalGuiaVisible: false })}
          onSuccess={(datosGuia) => {
            this.setState({ modalGuiaVisible: false });
            this.selectVentas();

            if (datosGuia && datosGuia.labelUrl) {
              const serieAct = this.state.ventas.find(
                (v) => v._id === selectedVentaId,
              )?.serieNumero;

              this.setState({
                modalPreviewVisible: true,
                archivoPreview: {
                  url: datosGuia.labelUrl,
                  name: `Guia_${serieAct}.pdf`,
                  mime: "application/pdf",
                },
              });
            }
          }}
        />
        <ModalGenerarOCDropshipping
          visible={this.state.modalOCVisible}
          ventaId={this.state.selectedVentaId}
          origenKey={this.state.selectedOrigenKey}
          onCancel={() => this.setState({ modalOCVisible: false })}
          onSuccess={() => {
            this.setState({ modalOCVisible: false });
            this.selectVentas();
          }}
        />
        <ModalPrevisualizarArchivos
          visible={this.state.modalPreviewVisible}
          onClose={() => this.setState({ modalPreviewVisible: false })}
          file={this.state.archivoPreview}
        />
        <ModalProgramarRecoleccion
          visible={this.state.modalRecoleccionVisible}
          carrier={this.state.recoleccionCarrier}
          origenKey={this.state.recoleccionOrigen}
          ventasLocal={this.state.ventas}
          onCancel={() => this.setState({ modalRecoleccionVisible: false })}
          onSuccess={() => {
            this.setState({ modalRecoleccionVisible: false });
            this.selectVentas();
          }}
        />
        <ModalConfirmarTransito
          visible={this.state.modalTransitoVisible}
          venta={this.state.transitoVenta}
          envio={this.state.transitoEnvio}
          origenKey={this.state.transitoOrigenKey}
          enviarCorreoDefault={this.getEnviarCorreoDefault(4, this.state.transitoOrigenKey)}
          onCancel={() => this.setState({ modalTransitoVisible: false })}
          onSuccess={() => {
            this.setState({ modalTransitoVisible: false });
            this.selectVentas();
          }}
        />
        <ModalGenerarGuiaManual
          visible={this.state.modalGuiaManualVisible}
          ventaId={selectedVentaId}
          origenKey={selectedOrigenKey}
          soloActualizar={this.state.soloActualizarEmpaquetado}
          enviarCorreoDefault={this.getEnviarCorreoDefault(2, selectedOrigenKey)}
          onCancel={() =>
            this.setState({
              modalGuiaManualVisible: false,
              soloActualizarEmpaquetado: false,
            })
          }
          onSuccess={(datosGuia) => {
            this.setState({ modalGuiaManualVisible: false });
            this.selectVentas();

            if (datosGuia && datosGuia.labelUrl) {
              const serieAct = this.state.ventas.find(
                (v) => v._id === selectedVentaId,
              )?.serieNumero;
              this.setState({
                modalPreviewVisible: true,
                archivoPreview: {
                  url: datosGuia.labelUrl,
                  name: `Guia_${serieAct}.pdf`,
                  mime: "application/pdf",
                },
              });
            }
          }}
        />
        <ModalConfirmarEstadoConCorreo
          visible={this.state.modalEstadoCorreoVisible}
          venta={this.state.estadoCorreoVenta}
          envio={this.state.estadoCorreoEnvio}
          origenKey={this.state.estadoCorreoOrigen}
          nuevoEstado={this.state.estadoCorreoNuevoEstado}
          enviarCorreoDefault={this.getEnviarCorreoDefault(
            this.state.estadoCorreoNuevoEstado,
            this.state.estadoCorreoOrigen,
          )}
          onCancel={() => this.setState({ modalEstadoCorreoVisible: false })}
          onSuccess={() => {
            this.setState({ modalEstadoCorreoVisible: false });
            this.selectVentas();
          }}
        />
        <ModalConfirmarPagoTransferencia
          visible={this.state.modalConfirmarTransferenciaVisible}
          venta={this.state.ventaAConfirmarTransferencia}
          onCancel={() =>
            this.setState({ modalConfirmarTransferenciaVisible: false })
          }
          onSuccess={() => {
            this.setState({ modalConfirmarTransferenciaVisible: false });
            this.selectVentas();
          }}
        />
        <ModalConciliarTransferenciasExcel
          visible={this.state.modalConciliarExcelVisible}
          onCancel={() => {
            this.setState({ modalConciliarExcelVisible: false });
            this.selectVentas();
          }}
          onSuccess={() => {
            this.setState({ modalConciliarExcelVisible: false });
            this.selectVentas();
          }}
        />
        <ModalGenerarPickingLote
          visible={this.state.modalPickingLoteVisible}
          onCancel={() => this.setState({ modalPickingLoteVisible: false })}
        />
        <ModalEstadoGeneralPedido
          visible={this.state.modalEstadoGeneralVisible}
          ventaId={this.state.estadoGeneralVentaId}
          onCancel={() =>
            this.setState({
              modalEstadoGeneralVisible: false,
              estadoGeneralVentaId: null,
            })
          }
        />
        <ModalConfirmarEmpaquetadoSucursal
          visible={this.state.modalEmpaqueSucursalVisible}
          ventaId={selectedVentaId}
          origenKey={selectedOrigenKey}
          soloActualizar={this.state.soloActualizarEmpaquetado}
          enviarCorreoDefault={this.getEnviarCorreoDefault(2, "entrega_sucursal")}
          onCancel={() =>
            this.setState({
              modalEmpaqueSucursalVisible: false,
              soloActualizarEmpaquetado: false,
            })
          }
          onSuccess={() => {
            this.setState({ modalEmpaqueSucursalVisible: false });
            this.selectVentas();
          }}
        />
        {createPortal(
          <DragOverlay dropAnimation={null}>
            {this.state.activeId ? (
              <div
                style={{
                  width: "280px",
                  transform: "rotate(3deg)",
                  cursor: "grabbing",
                  zIndex: 10000,
                }}
              >
                {this.state.activeTipo === "grupo" ? (
                  <TarjetaGrupoInsumos
                    venta={this.state.activeVenta}
                    envio={this.state.activeEnvio}
                    insumos={this.state.activeInsumosGrupo || []}
                    estado={this.state.activeEstadoGrupo}
                    onSeguirEmpaquetando={() => {}}
                  />
                ) : (
                  <VentaOnlineCard
                    venta={this.state.activeVenta}
                    envio={this.state.activeEnvio}
                    mostrarDetalles={this.state.mostrarDetalles}
                  />
                )}
              </div>
            ) : null}
          </DragOverlay>,
          document.body,
        )}
      </DndContext>
    );
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
  escuelaActivo: !!state.empresa.escuela,
  permisoAccesoEcommerce:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "697e2c2db47586150a762dc9",
    )?.activado,
  permisoConfirmarPago:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a28321b2f290af9f3d913e8",
    )?.activado,
});

export default connect(mapStateToProps)(VentasEcommerceDashboard);
